import { connect } from 'react-redux';
import { appActions } from '../../app/app.actions';
import RakutenService from './rakutenServices/RakutenService';
import UCRM from './ucrm/UCRM';
import { privacyCenterActions } from './privacyCenter.actions';

function mapStateToProps(state) {
    return {
        appConfig: state.app.appConfig,
        locale: state.app.locale,
        services: state.privacyCenter.services,
        recommendations: state.privacyCenter.recommendations,
        servicesConfig: state.privacyCenter.servicesConfig,
        gettingServicesAndConsentsStatus: state.privacyCenter.gettingServicesAndConsentsStatus,
        loadingServicesConfig: state.privacyCenter.loadingServicesConfig,
        loadingServicesConfigError: state.privacyCenter.loadingServicesConfigError,
        clientConfig: state.app.clientConfig,
        memberLoggedIn: state.app.memberLoggedIn,
        member: state.member,
        localeSet: state.app.locale,
        supportPageUrl:
            state.app.clientConfig.supportPageUrl || 'mailto:rakuten-privacy@mail.rakuten.com',
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.PRIVACY
            : '',
        dsrStatuses: state.privacyCenter.dsrStatuses,
        dsrFormOpen: state.privacyCenter.dsrFormOpen,
        activeServiceUuid: state.privacyCenter.activeServiceUuid,
        deleting: state.privacyCenter.deleting,
        showDSRDeleteStatusInfo: state.privacyCenter.showDSRDeleteStatusInfo,
        socialUnlinkFormOpen: state.privacyCenter.socialUnlinkFormOpen,
        activeSocialProvider: state.privacyCenter.activeSocialProvider,
        activeSocialProviderName: state.privacyCenter.activeSocialProviderName,
        activeSocialUnlinkTargetId: state.privacyCenter.activeSocialUnlinkTargetId,
        unlinkingSocial: state.privacyCenter.unlinkingSocial,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadServicesConfig: () => {
            dispatch(privacyCenterActions.loadServicesConfig());
        },
        loadRecommendedEUServices: () => {
            dispatch(privacyCenterActions.loadRecommendedEUServices());
        },
        updateOptionalConsentStatus: (serviceObj, locale) => {
            dispatch(privacyCenterActions.updateConsentStatus(serviceObj, locale));
        },
        deleteAccount: (member, password) => {
            dispatch(privacyCenterActions.cancelMembership(member, password));
        },
        getServicesLinksAndConsentsStatus: (lang) => {
            dispatch(privacyCenterActions.loadServicesAndConsentsStatus(lang));
        },
        startDeleteAccount: () => {
            dispatch(privacyCenterActions.startDeleteAccount());
        },
        trackExternalLink: (name) => {
            dispatch(appActions.trackExternalLinkClick(name));
        },
        trackAgreementClick: (data) => {
            dispatch(appActions.trackAgreement(data));
        },
        submitDsrRequest: (body, password) => {
            dispatch(privacyCenterActions.submitDsrRequest(body, password));
        },
        openDSRForm: (serviceUuid) => {
            dispatch(privacyCenterActions.openDSRForm(serviceUuid));
        },
        closeDSRForm: () => {
            dispatch(privacyCenterActions.closeDSRForm());
        },
        toggleDSRDeleteStatusInfo: (serviceUuid, value) => {
            dispatch(privacyCenterActions.toggleDSRDeleteStatusInfo(serviceUuid, value));
        },
        unlinkSocialProvider: (providerId, providerName, unlinkTargetId) => {
            dispatch(
                privacyCenterActions.unlinkSocialProvider(providerId, providerName, unlinkTargetId),
            );
        },
        openSocialUnlinkForm: (providerId, providerName, unlinkTargetId) => {
            dispatch(
                privacyCenterActions.openSocialUnlinkForm(providerId, providerName, unlinkTargetId),
            );
        },
        closeSocialUnlinkForm: () => {
            dispatch(privacyCenterActions.closeSocialUnlinkForm());
        },
    };
}

export const RakutenServiceContainer = connect(mapStateToProps, mapDispatchToProps)(RakutenService);

export const UCRMContainer = connect(mapStateToProps, mapDispatchToProps)(UCRM);
